var map = {
	"./Android-icon.png": "8ccb",
	"./Android.png": "3065",
	"./Microsoft.png": "32aa",
	"./WeChat-icon.png": "6552",
	"./account/CHECKING-e.png": "84794",
	"./account/CHECKING-f.png": "5d30",
	"./account/CHECKING.png": "4f66",
	"./account/CLOSE-e.png": "3ef1",
	"./account/CLOSE-f.png": "4472",
	"./account/CLOSE.png": "ebde",
	"./account/FOREX@2x.png": "d965",
	"./account/FUND@2x.png": "a260",
	"./account/FUTURES@2x.png": "d1ee",
	"./account/OPEN-e.png": "b080",
	"./account/OPEN-f.png": "68cc",
	"./account/OPEN.png": "db65",
	"./account/PM@2x.png": "88f1",
	"./account/REJECT-e.png": "80b8",
	"./account/REJECT-f.png": "c688",
	"./account/REJECT.png": "5517",
	"./account/STOCK@2x.png": "d48e",
	"./account/STOP-e.png": "c802",
	"./account/STOP-f.png": "8e02",
	"./account/STOP.png": "ac8a",
	"./account/aggressive.png": "0b90",
	"./account/balance.png": "54f1",
	"./account/conservative.png": "e75f",
	"./account/growth.png": "c2d7",
	"./account/icon_submit.png": "5f9a",
	"./account/quotation.png": "d958",
	"./account/risklevelR1.png": "a205",
	"./account/risklevelR2.png": "874d",
	"./account/risklevelR3.png": "4cce",
	"./account/risklevelR4.png": "6086",
	"./account/risklevelR5.png": "9071",
	"./account/robust.png": "fbb1",
	"./banklogo/BC.png": "7673",
	"./banklogo/BCM.png": "d586",
	"./banklogo/BEA.png": "43e3",
	"./banklogo/BOC.png": "047b",
	"./banklogo/BOCM.png": "81ff",
	"./banklogo/CBC.png": "2fc1",
	"./banklogo/CBCL.png": "99fb",
	"./banklogo/CCB.png": "bbe4",
	"./banklogo/CCBL.png": "9ef0",
	"./banklogo/CHB.png": "6f49",
	"./banklogo/CITIBANK.png": "cae8",
	"./banklogo/CMB.png": "cc2f",
	"./banklogo/CMBC.png": "e0ca",
	"./banklogo/Citibank.png": "9afb",
	"./banklogo/DBS.png": "c1a5",
	"./banklogo/DBSB.png": "5f75",
	"./banklogo/DSB.png": "550a",
	"./banklogo/FPS.png": "cdb2",
	"./banklogo/HSB.png": "ef33",
	"./banklogo/HSBC.png": "ac68",
	"./banklogo/ICBC.png": "7f95",
	"./banklogo/NCB.png": "4574",
	"./banklogo/OCBC.png": "4876",
	"./banklogo/OTHER.png": "29107",
	"./banklogo/SCB.png": "e34e",
	"./banklogo/SIB.png": "2273",
	"./banklogo/ZA.png": "ba7f",
	"./banklogo/ZAB.png": "b074",
	"./convert.png": "630d",
	"./correct.png": "e4db",
	"./currency/存入人民币.png": "8066",
	"./currency/存入港币.png": "1a26",
	"./currency/存入美元.png": "a154",
	"./deposit/ATM transfer.png": "b135",
	"./deposit/Cheque deposit.png": "72a5",
	"./deposit/Counter transfer.png": "9db2",
	"./deposit/FPS-e.png": "7f0f",
	"./deposit/FPS.png": "5e46",
	"./deposit/Online banking transfer.png": "d0cd",
	"./deposit/subAccount.png": "2484",
	"./deposit_steps.png": "6ba7",
	"./download-icon.png": "0b64",
	"./download/Android.png": "21f6",
	"./download/Microsoft.png": "74fe",
	"./download/download-icon.png": "c1a6",
	"./download/eddidlite.png": "0a1d",
	"./download/eddidpro.png": "6e7d",
	"./download/iOS.png": "d6b7",
	"./download/manual.png": "fd5e",
	"./download/security-code.png": "8806",
	"./download/software.png": "ae17",
	"./download/web.png": "27b9",
	"./eddid-pro.png": "6fbc",
	"./facebook-icon.png": "2d6d",
	"./failure-zhans.png": "cec9",
	"./failure-zhant.png": "130f",
	"./forex-q.png": "ea3a",
	"./forex.png": "e8a5",
	"./forgetPwd.png": "62ae",
	"./futures-q.png": "a500",
	"./fx_pro_Android.png": "fa35",
	"./fx_pro_iOS.png": "f7b0",
	"./help.png": "dfdd",
	"./home.png": "28ea",
	"./iOS.png": "bea6",
	"./icon_download.png": "9335",
	"./icon_hint@2x.png": "41f2",
	"./icon_nor@2x.png": "03fe",
	"./icon_refresh.png": "0aaf",
	"./icon_sel@2x.png": "45d3",
	"./icon_tishi.png": "d030",
	"./img_hk.png": "f68c",
	"./img_us.png": "4c1d",
	"./initial-zhans.png": "e571",
	"./initial-zhant.png": "d103",
	"./ios-icon.png": "ff2d",
	"./logo.png": "9d64",
	"./logo/eddid-unlock.png": "3ae9",
	"./logo/page2_JAVA.png": "54f7",
	"./logo/page2_android.png": "5d58",
	"./logo/page2_ios.png": "da61",
	"./logo/page2_windows.png": "bcdf",
	"./muen.png": "8f53",
	"./no-data.png": "ac8d",
	"./noDeposit.png": "7c51",
	"./noFundertransfer.png": "7c37",
	"./noWithdrawal.png": "97a4",
	"./notice.png": "5114",
	"./personalCenter/hy_ico_ck.png": "dc01",
	"./personalCenter/hy_ico_jg.png": "96cc",
	"./personalCenter/hy_ico_jy.png": "bb74",
	"./personalCenter/hy_ico_kf.png": "592e",
	"./personalCenter/hy_ico_pt copy.png": "c4bc",
	"./personalCenter/hy_ico_pt.png": "6cd0",
	"./personalCenter/hy_ico_qk.png": "409b3",
	"./personalCenter/hy_ico_xz.png": "19d4",
	"./personalCenter/hy_ico_zh.png": "4aee",
	"./personalCenter/hy_ico_zi.png": "dd09",
	"./personalCenter/hy_ico_zz.png": "c2cd",
	"./personalCenter/hy_ico_zzh.png": "7cd4",
	"./player.png": "1179",
	"./plus.png": "cf27",
	"./pm.png": "5f61",
	"./qq-icon.png": "6b23",
	"./quotes/calendar.png": "289c",
	"./quotes/futures.png": "aa6e",
	"./quotes/global.png": "edf4",
	"./quotes/hk_stock.png": "76b3",
	"./quotes/img_hk.png": "40a6",
	"./quotes/img_us.png": "9fa4",
	"./quotes/mixin.png": "4cbd",
	"./quotes/us_stock.png": "cd03",
	"./records-canceled-en.png": "9b74",
	"./records-canceled-zhans.png": "02f6",
	"./records-canceled-zhant.png": "9912",
	"./records-completed-en.png": "b566",
	"./records-completed-zhans.png": "8f77",
	"./records-completed-zhant.png": "eb4c",
	"./records-failure-en.png": "e94a",
	"./records-failure-zhans.png": "925e",
	"./records-failure-zhant.png": "2690",
	"./records-processing-en.png": "a0ae",
	"./records-processing-zhans.png": "2e99",
	"./records-processing-zhant.png": "3787",
	"./records-submitted-en.png": "636d",
	"./records-submitted-zhans.png": "1d63",
	"./records-submitted-zhant.png": "10ea",
	"./review-success-en.png": "97c4",
	"./review-success-zhans.png": "dfe7",
	"./review-success-zhant.png": "a578",
	"./reviewing-en.png": "0050",
	"./reviewing-zhans.png": "171e",
	"./reviewing-zhant.png": "6032",
	"./securities-q.png": "d51f",
	"./securities.png": "b0ab",
	"./security-code.png": "d9a0",
	"./security_code_ios.png": "8256",
	"./signature_sample.png": "168f",
	"./signature_sample_en.png": "a559",
	"./signature_sample_hant.png": "f0ef",
	"./stock.png": "76e6",
	"./success.png": "46e6",
	"./table-down.png": "3052",
	"./video-play.png": "03af",
	"./web.png": "6436",
	"./withdrawn.png": "4d57",
	"./wrong.png": "bf27",
	"./下拉箭头.png": "d015",
	"./停止交易.png": "2f4f",
	"./入金.png": "936d",
	"./内部转账.png": "0276",
	"./出金.png": "33df",
	"./开始交易.png": "9b59",
	"./成功提交.png": "fcdb",
	"./我的账户.png": "0cfb",
	"./无子账户.png": "4b81",
	"./查看更多.png": "c765",
	"./消息通知无消息.png": "011d",
	"./消息通知有消息.png": "a59d",
	"./登录页面艾德logo.png": "21eb",
	"./退出登录.png": "2525"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";